// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticlesTagsOptionCheckIcon-module__container--e2kl6,.ArticlesTagsOptionCheckIcon-module__containerChecked--JJ61q{display:flex;align-items:center;justify-content:center;display:inline-flex;width:16px;height:16px;border-radius:4px}.ArticlesTagsOptionCheckIcon-module__container--e2kl6{border:1px solid #d4d6d7}.ArticlesTagsOptionCheckIcon-module__containerChecked--JJ61q{background-color:#307fe2}.ArticlesTagsOptionCheckIcon-module__icon--CSqMV{width:10px;height:10px;stroke:#fff}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ArticlesTagsOptionCheckIcon-module__container--e2kl6`,
	"containerChecked": `ArticlesTagsOptionCheckIcon-module__containerChecked--JJ61q`,
	"icon": `ArticlesTagsOptionCheckIcon-module__icon--CSqMV`
};
export default ___CSS_LOADER_EXPORT___;
